import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import * as moment from 'moment'
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { TrainingEventSubscription, AttendanceStatusTypes, SubscriptionMethodTypes } from '../../models/domain/training.event.subscription';
import { TrainingEvent } from '../../../app/models/domain/training.event';
import { AddTrainingEventSubscriptionOnlyRequest } from '../../../app/models/ss-api/requests/add.training.event.subscription.only.request';
import { Router } from '@angular/router';

export interface IRescheduleAttendeeDialogModel {
    title: string;
    Attendee: TrainingEventSubscription;
    Event: TrainingEvent;
}

interface CalendarEvent {
    title: String;
    start: Date;
    end: Date;
    event: TrainingEvent;
}

@Component({
    selector: 'reschedule-attendee-dialog',
    styleUrls: ['./reschedule.attendee.dialog.css'],
    templateUrl: './reschedule.attendee.dialog.html'
})

export class RescheduleAttendeeDialog extends DialogComponent<IRescheduleAttendeeDialogModel, Boolean> implements IRescheduleAttendeeDialogModel, OnInit {
    IsBusy: Boolean = true;
    title: string;
    Event: TrainingEvent;
    Events: CalendarEvent[];
    Attendee: TrainingEventSubscription;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        let request = {
            StartDate: moment().subtract(12, 'hours').toDate(),
            EndDate: moment().add(30, 'days').toDate()
        }

        let tempEvents = [];
        let eventTemplate: CalendarEvent;

        let disposable = this.api.GetAdminTrainingCalendar(request).subscribe(response => {
            response.Data['TrainingEvents'].forEach(function (event: TrainingEvent) {
                let trainingClass = response.Data['TrainingClasses'].filter(c => c.ID == event.TrainingClassID)[0];
                if (event.ID != this.Event.ID && this.MemberHasProductForEvent(trainingClass.ProductIDs)) {
                    let duration = moment(trainingClass.ClassDuration, 'hh:mm:ss');
                    eventTemplate = {
                        title: trainingClass.ClassTitle,
                        start: new Date(event.EventDateTime),
                        end: moment(event.EventDateTime).add({ hours: duration.hours(), minutes: duration.minutes() }).toDate(),
                        event: event
                    }
                    eventTemplate.event.TrainingClass = trainingClass;
                    tempEvents.push(eventTemplate);
                }
            }, this)

            // console.log(tempEvents);
            this.Events = tempEvents;
            disposable.unsubscribe();
            this.IsBusy = false;
        })
    }

    MemberHasProductForEvent(products): boolean {
        if (products.indexOf(this.Attendee.Original_Product_ID) >= 0) {
            return true;
        }
        return false;
    }

    ProductsForEvent(event: TrainingEvent) {
        let productHTML = '';
        let productBorder = '';

        event.TrainingClass.ProductIDs.forEach(function (product) {
            let icon = '';
            let color = '#000';
            switch (product) {
                case 3:
                    icon = '../../assets/images/icons/logo-icons-vip3d-xs.png';
                    color = '#0064DF';
                    break;
                case 2:
                    icon = '../../assets/images/icons/logo-icons-pool-studio-xs.png';
                    color = '#FF0000';
                    break
                case 1:
                    icon = '../../assets/images/icons/logo-icons-vizterra-xs.png';
                    color = '#64A000';
                    break
                default:
                    return false;
            }
            productHTML += '<img class="event-software-icon" style="border-color: ' + color + '" src="' + icon + '" />'
            productBorder += '<div class="event-product-section" style="background-color: ' + color + '"></div>'
        }, this)

        return {
            ProductIcons: productHTML,
            ProductBorder: productBorder
        }
    }

    SelectEvent(event: TrainingEvent) {
        this.IsBusy = true;
        let request: AddTrainingEventSubscriptionOnlyRequest = {
            TrainingEvent_ID: event.ID,
            License_ID: this.Attendee.License_ID,
            AttendanceStatusType: AttendanceStatusTypes.Registered,
            AlternateEmail: this.Attendee.AlternateEmail,
            AlternatePhone: this.Attendee.AlternatePhone,
            SubscriptionMethodType: SubscriptionMethodTypes.Admin,
            SubscriptionNotes: this.Attendee.SubscriptionNotes + ' Rescheduled by ' + this.gb.FirstName + ' on ' + moment().format('MMMM Do YYYY, h:mm a')
        }

        let disposable = this.api.AddTrainingEventSubscription(request).subscribe(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Rescheduled Successfully',
                    text: 'Rescheduled attendee without any errors',
                    timer: 1500
                }).then(() => { }, () => { })
                this.result = true;
                this.IsBusy = false;
                this.close();
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then(() => { }, () => { })
                this.result = false;
                this.IsBusy = false;
                this.close();
            }
            disposable.unsubscribe();
        })
    }

    confirm() {
        this.result = false;
        this.close();
    }

}
